import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconBandage from '@/icons/Bandage.svg';
import { computeDuplicateDefectNumber, useGetDefectName } from '@/models/defectType';
import { ArticleDefectWithRelations, ArticleWithRelations } from '@/models/request';
import useViewPort from '@/utils/useViewport';

import { WithContext } from './WithContext';

export const DefectName = ({
  defect,
  isDisabled = false,
  article,
}: {
  defect: ArticleDefectWithRelations;
  isDisabled?: boolean;
  article: ArticleWithRelations;
}) => {
  const { isMobile } = useViewPort();

  const defects = article.snapshot.articleDefects;

  const getDefectName = useGetDefectName();
  const duplicateNumber = computeDuplicateDefectNumber(defect, defects);

  return (
    <WithContext context={defect.context}>
      <Stack row gap="4px" alignItems="center">
        <IconBandage
          style={{
            fontSize: isMobile ? '1rem' : '1.25rem',
            color: isDisabled ? 'var(--color-text-disabled-black)' : undefined,
          }}
        />
        <Paragraph size={isMobile ? '200' : '100'} color={isDisabled ? 'disabled' : undefined}>
          {getDefectName(defect)}
          {defects.length > 1 && duplicateNumber ? ` #${duplicateNumber}` : ''}
        </Paragraph>
      </Stack>
    </WithContext>
  );
};
